import styled, { css } from 'styled-components';

interface IMenuProps {
  active: boolean;
}

export const Container = styled.header`
  top: 0;
  background: transparent;
  z-index: 100;

  .container {
    max-width: 1446px;
  }

  .menu-fix {
    width: 100%;

    position: fixed;
    z-index: 1000;
    transition-duration: 0.3s;
    background: #1a1916;
    top: 0;
  }

  .name {
    color: #e4e4e4;
    font-family: 'Inter';
    font-size: 32px;
    font-weight: 500;
  }

  @media screen and (min-width: 991px) {
    .menu-fix {
      width: 100%;
    }
  }
`;

export const Menu = styled.div<IMenuProps>`
  .logout {
    position: absolute;
    right: 50px;
    top: -10px;
    border-radius: 18px;
    background: #fff;
    color: #000;
    padding: 5px 32px 5px 15px;
    font-family: 'Source Sans Pro';
    font-size: 20px;
    font-weight: 600;
  }

  .first-letter {
    color: #fff;
    position: absolute;
    text-align: center;
    font-family: 'Source Sans Pro';
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    line-height: 15.5px;
    right: 12px;
    top: 12px;
  }
  .nav-btn {
    width: 25px;
    height: 25px;

    span {
      display: block;
      width: 100%;
      height: 1.5px;
      background-color: #fff;
      border-radius: 30px;
      transition-duration: 0.5s;

      :nth-child(2) {
        margin: 6px 0px;
      }

      ${(props) =>
        props.active &&
        css`
          :nth-child(1) {
            transform: rotate(225deg);
          }

          :nth-child(2) {
            opacity: 0;
            transform: rotate(225deg);
          }

          :nth-child(3) {
            transform: rotate(315deg);
            margin-top: -15px;
          }
        `}
    }
  }

  .menu-group {
    transition-duration: 0.3s;
    width: 100%;
    position: absolute;
    left: ${(props) => (props.active ? 0 : 1000)}px;
    background-color: ${(props) => (props.active ? '#fff' : 'transparent')};
    min-height: calc(100vh - 65px);
    top: 65px;

    .menu {
      min-height: calc(100vh - 65px);

      .btn-menu {
        transition-duration: 0.3s;
        color: #202020;
        -webkit-text-stroke-width: 1px;
        -webkit-text-stroke-color: transparent;
        -webkit-text-fill-color: #202020;
        position: relative;

        :after {
          content: '';
          position: absolute;
          width: 9px;
          height: 9px;
          border-radius: 50%;
          bottom: -10px;
          transition-duration: 0.3s;
        }
      }

      .btn-menu:hover,
      .btn-menu.active {
        -webkit-text-stroke-color: #202020;

        :after {
          background-color: #202020;
        }
      }
    }
  }

  @media screen and (min-width: 991px) {
    .menu-group {
      width: auto;
      position: unset;
      background-color: transparent;
      min-height: unset;

      .menu {
        min-height: unset;

        .btn-menu {
          color: #fff;
          -webkit-text-fill-color: #fff;
          :after {
            content: '';
            position: absolute;
            width: 9px;
            height: 9px;
            border-radius: 50%;
            bottom: -10px;
            transition-duration: 0.3s;
          }
        }

        .btn-menu:hover,
        .btn-menu.active {
          -webkit-text-stroke-color: #fff;

          :after {
            background-color: #fff;
          }
        }
      }
    }
  }
`;
